<ui-modal
  [isOpened]="modalOpen"
  modalTitle="Trade Status"
  (isOpenedChange)="modalChanged($event)"
>
  <form clrForm class="search">
    <clr-input-container>
      <label>Search</label>
      <input
        type="text"
        placeholder="Search"
        clrInput
        name="search"
        spellcheck="false"
        autocomplete="off"
        [(ngModel)]="search"
        (ngModelChange)="searchChanged($event)"
      />
    </clr-input-container>
  </form>
  <div class="trade-status">
    <table *ngIf="statuses" ui-table>
      <thead>
        <tr>
          <th class="name">Name</th>
          @for (r of statuses.statuses; track $index) {
            <th>
              {{ r }}
            </th>
          }
        </tr>
        @for (r of filteredStatuses.allowed_statuses; track $index) {
          <tr>
            <td class="name">{{ r.longName }}</td>
            @for (k of statuses.statuses; track $index) {
              <td class="check">
                @if (r.statuses[k]) {
                  <cds-icon shape="check"></cds-icon>
                }
              </td>
            }
          </tr>
        }
      </thead>
    </table>
  </div>
</ui-modal>
